import styled from 'styled-components'
import {
  PendingIcon,
  DueIcon,
  OverdueIcon,
  CompletedIcon,
  MissedIcon,
  SkippedIcon,
} from './icons'
import { Text } from '../../general'
import { theme } from '../../config/theme'
import { CalculatedTaskStatus } from '@lmc/ts-common'

const BadgeIconMap = {
  [CalculatedTaskStatus.pending]: <PendingIcon />,
  [CalculatedTaskStatus.due]: <DueIcon />,
  [CalculatedTaskStatus.overdue]: <OverdueIcon />,
  [CalculatedTaskStatus.completed]: <CompletedIcon />,
  [CalculatedTaskStatus.missed]: <MissedIcon />,
  [CalculatedTaskStatus.skipped]: <SkippedIcon />,
}

type StatusBadgeProps = {
  count?: number
  status: CalculatedTaskStatus
  leftText?: boolean
  showStatus?: boolean
  hasBorder?: boolean
  className?: string
}

const StatusBadge = ({
  leftText,
  count,
  status,
  showStatus,
  hasBorder,
  className,
}: StatusBadgeProps) => (
  <StatusBadgeContainer
    $border={hasBorder ? `1px solid ${theme.color.neutral.color7}` : 'none'}
    className={className}
  >
    {leftText ? (
      <>
        <LeftStatus level={1}>{status}</LeftStatus>
        {BadgeIconMap[status]}
      </>
    ) : (
      <>
        {BadgeIconMap[status]}
        {count !== undefined && count >= 0 && (
          <CountContainer
            color={
              showStatus
                ? theme.color.neutral.color2
                : theme.color.neutral.color5
            }
          >
            <Count level={1} weight={showStatus ? 'bold' : 'regular'}>
              {count}
            </Count>
          </CountContainer>
        )}
        {showStatus && <RightStatus level={1}>{status}</RightStatus>}
      </>
    )}
  </StatusBadgeContainer>
)
const StatusBadgeContainer = styled.div<{ $border: string }>`
  display: inline-flex;
  align-items: center;
  border: ${(props) => props.$border};
  border-radius: 4px;
  color: ${({ theme }) => theme.color.neutral.color10};
`

const CountContainer = styled.div<{ color: string }>`
  color: ${(props) => props.color};
  margin-left: 8px;
`

const Count = styled(Text)`
  margin-left: 0 8px;
`

const LeftStatus = styled(Text)`
  text-transform: capitalize;
  margin-right: 8px;
  color: ${({ theme }) => theme.color.neutral.color4};
`

const RightStatus = styled(Text)`
  text-transform: capitalize;
  margin-left: 8px;
  color: ${({ theme }) => theme.color.neutral.color4};
`

export default StatusBadge
